import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule} from '@angular/material/button';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';

import { FileUploadModule } from 'ng2-file-upload';

import { DialogUploadRoutingModule } from './dialog-upload-routing.module';
import { DialogUploadComponent } from './dialog-upload.component';

@NgModule({
  imports: [
    CommonModule,
    DialogUploadRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    // FlexLayoutModule,
    MatSnackBarModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    FileUploadModule,
  ],
  declarations: [
    DialogUploadComponent
  ],
})
export class DialogUploadModule { }
